import { EMPLOYEES_API_BASE_URL, MEALS_API_BASE_URL } from "./config";

export class AuthApi {
  static baseUrl = EMPLOYEES_API_BASE_URL;

  static getToken({ username, password }) {
    return fetch(`${AuthApi.baseUrl}/auth/token/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
        password,
      }),
    })
      .then((response) => response.json())
      .then((result) => result["token"]);
  }
}

export class EmployeesApi {
  static baseUrl = `${EMPLOYEES_API_BASE_URL}/v1`;

  static searchEmployee(inputValue, options) {
    return fetch(
      `${EmployeesApi.baseUrl}/employees/?is_active=true&search=${inputValue}`,
      {
        ...options,
      }
    )
      .then((response) => response.json())
      .then((result) => result["results"]);
  }

  static getEmployeeById(id, options) {
    return fetch(`${EmployeesApi.baseUrl}/employees/?is_active=true&id=${id}`, {
      ...options,
    })
      .then((response) => response.json())
      .then((result) => result["results"][0]);
  }

  static async getEmployeeByPhoto(photo, options) {
    let formdata = new FormData();
    formdata.append("photos", photo, "file0.jpg");

    let requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      ...options,
    };

    try {
      const response = await fetch(
        `${EmployeesApi.baseUrl}/employees/list_post/`,
        requestOptions
      );
      const json = await response.json();

      return [json[0]];
    } catch (error) {
      return [null, error];
    }
  }

  static saveEmployeePhoto(employeeId, photo, isUserCorrect, options) {
    let formdata = new FormData();

    formdata.append("photo", photo, "file.jpg");
    formdata.append("employee", employeeId);
    formdata.append("employee_id", employeeId);
    formdata.append("is_valid", isUserCorrect);
    formdata.append("source", "CANTEEN");

    let requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow",
      ...options,
    };
    return fetch(`${EmployeesApi.baseUrl}/faces/`, requestOptions)
      .then((response) => response.json())
      .then((result) => result[0]);
  }
}

export class MealsApi {
  static baseUrl = MEALS_API_BASE_URL;

  static async getMenu() {
    // category_exclude=16 убирает сувениры
    try {
      const r = await fetch(`${MealsApi.baseUrl}/menu/`);
      if (r.ok) {
        const data = await r.json();
        return data;
      } else {
        return {};
      }
    } catch (e) {
      console.log(e);
      return {};
    }
  }

  static async sendOrder(data) {
    let requestOptions = {
      method: "POST",
      body: JSON.stringify(data),
      redirect: "follow",
      headers: {
        "Content-Type": "application/json",
      },
    };
    return fetch(`${MealsApi.baseUrl}/order/`, requestOptions).then(
      (response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error("Something went wrong");
        }
      }
    );
  }

  static sendRecognitionMetric(value) {
    if (typeof value === "boolean" || value === null) {
      const stringValue = value === null ? "none" : value.toString();

      return fetch(
        `${MealsApi.baseUrl}/metrics/face_recognition/${stringValue}/`,
        { method: "PUT" }
      );
    }
  }
}
